import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './IntroBanner.module.scss'
import Container from '../../container/Container'

function IntroBanner({
  title,
  subHeading,
  backgroundColor,
  appendItems,
  backgroundImage,
  fullImageHeight,
  whiteText,
  imageBottomOnMobile,
  className,
  heading,
  precontent,
}) {
  return (
    <Container
      className={classNames(
        styles.section,
        fullImageHeight && styles.fullImageWrapper,
        className
      )}
      style={{ backgroundColor }}
      fluid
    >
      <div
        className={classNames(
          styles.wrapper,
          imageBottomOnMobile && styles.imageBottomOnMobile
        )}
      >
        <div className={styles.intro}>
          <div className={styles.titleText}>
            <div>
              {precontent}
              {title && (
                <h1
                  className={classNames(
                    styles.title,
                    whiteText && styles.white
                  )}
                >
                  {title}
                </h1>
              )}
              {heading && (
                <h2
                  className={classNames(
                    styles.heading,
                    whiteText && styles.white
                  )}
                >
                  {heading}
                </h2>
              )}
            </div>
            {subHeading && (
              <h3
                className={classNames(
                  styles.subHeading,
                  whiteText && styles.white
                )}
              >
                {subHeading}
              </h3>
            )}
          </div>
          {appendItems}
        </div>
        <div className={classNames(fullImageHeight && styles.fullImage)}>
          {backgroundImage}
        </div>
      </div>
    </Container>
  )
}

IntroBanner.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  whiteText: PropTypes.bool,
  backgroundImage: PropTypes.element,
  appendItems: PropTypes.element,
}

export default IntroBanner
